export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  requiredPermission?: 'admin' | 'write' | 'read'
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'operations',
      displayName: 'menu.operations',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
      children: [
        {
          name: 'dashboard',
          displayName: 'menu.dashboard',
        },
        {
          name: 'orders',
          displayName: 'menu.orders',
        },
      ],
    },
    {
      name: 'catalog',
      displayName: 'menu.catalog',
      meta: {
        icon: 'inventory',
      },
      children: [
        {
          name: 'products',
          displayName: 'menu.products',
        },
        {
          name: 'product-mappings',
          displayName: 'menu.product-mappings',
          requiredPermission: 'admin',
        },
      ],
    },
    {
      name: 'system',
      displayName: 'menu.system',
      meta: {
        icon: 'settings',
      },
      children: [
        {
          name: 'users',
          displayName: 'menu.users',
          requiredPermission: 'admin',
        },
        {
          name: 'email-template',
          displayName: 'menu.email-template',
          requiredPermission: 'admin',
        },
        {
          name: 'preferences',
          displayName: 'menu.preferences',
        },
        {
          name: 'settings',
          displayName: 'menu.settings',
        },
      ],
    },
  ] as INavigationRoute[],
}
